import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import EmailFetchTasksSettingsForm from './EmailFetchTasksSettingsForm';
import i18n from 'i18n';

interface EmailFetchTasksSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeEmailFetchTask: number;
}

const EmailFetchTasksSettingsModal: React.FC<EmailFetchTasksSettingsModalProps> = React.memo(({
    modalOpen,
    closeModal,
    activeEmailFetchTask,
}) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_email_fetch_tasks_settings.text')}
        entityId={activeEmailFetchTask}
        FormComponent={EmailFetchTasksSettingsForm}
    />
));

export default EmailFetchTasksSettingsModal; 